import React, { useCallback } from "react";
import classnames from "classnames";
import { observer } from "mobx-react";

import { useStores } from "../../../context/StoreContext";
import { Select } from "../../common/Select";
import styles from "./index.scss";

const playbackOptions = [0.0625, 0.25, 0.5, 1, 2, 4, 8, 16];

function speedLabel(speed: number) {
    return `speed ${speed}X`;
}

export const PlaybackSpeedSelect = observer(function PlaybackSpeedSelect() {
    const { observeStore } = useStores();
    const handleChangeSpeed = useCallback(
        (value: number) => {
            observeStore.speed = value;
        },
        [observeStore],
    );
    return (
        <Select
            value={observeStore.speed}
            options={playbackOptions}
            bottom={true}
            icon="playback"
            label={speedLabel}
            title="Playback speed"
            responsive={true}
            className={classnames(styles.speed, styles.button)}
            onChange={handleChangeSpeed}
        />
    );
});
